(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["licensee-name"] && !Shopify.designMode) return;
  try {
    const isCartAddForm = (form) =>
    form instanceof HTMLFormElement && (form.action || '').includes('/cart/add');

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!isCartAddForm(form)) return;

      const field = form.querySelector('[data-licensee-name]');
      if (!field) return;

      field.value = field.value.trim();
      if (field.value !== '') {
        field.setCustomValidity('');
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
      field.setCustomValidity(field.dataset.licenseeError || 'This field is required.');
      field.reportValidity();
    },
    true
  );

  document.addEventListener('input', (event) => {
    const field = event.target;
    if (field instanceof HTMLElement && field.hasAttribute('data-licensee-name')) {
      field.setCustomValidity('');
    }
  });
  } catch(e) { console.error(e); }
})();

})();
